import * as React from 'react';
import { IgcDividerComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The igc-divider allows the content author to easily create a horizontal/vertical rule as a break between content to better organize information on a page.
 * @cssproperty --color - Sets the color of the divider.
 * @cssproperty --inset - Shrinks the divider by the given amount from the start. If `middle` is set it will shrink from both sides.
 * @class
 */
export const IgrDivider = /* @__PURE__ */ createComponent({
  tagName: 'igc-divider',
  displayName: 'IgrDivider',
  elementClass: Component,
  react: React,
});

export type IgrDivider = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrDividerModule = Component;
